import { useState, useEffect, useRef } from "react";
import { Input } from "@mui/material";
import { IoSend } from "react-icons/io5";
import styled from "styled-components";
import { IoEllipsisVertical } from "react-icons/io5";


export const ChatContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  height: 300px;
  width: 700px;
  display: flex;
  flex-direction: column;
`;

export const ChatBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px;
`;


export const MessageSystem = styled.div`
  text-align: center;
  color: #999;
  font-style: italic;
  margin: 5px 0;

  .hora {
    font-size: 10px;
    margin-left: 8px;
  }
`;

export const MessageMine = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;

  .message-container {
    background-color: #E5F7EE;
    padding: 10px 14px;
    border-radius: 10px;
    max-width: 75%;
    word-wrap: break-word;
    position: relative;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }

  .message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .message-body {
    font-size: 14px;
    margin: 4px 0;
  }

  .hora {
    font-size: 10px;
    text-align: right;
    color: #666;
    margin-top: 6px;
  }
`;

export const MoreOptionsMenu = styled.div`
  position: absolute;
  top: 28px;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  padding: 8px 0;
  z-index: 1000;

  button {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    padding: 8px 16px;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

export const MessageOther = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;

  div {
    background-color: #F0F0F0;
    padding: 8px 12px;
    border-radius: 8px;
    max-width: 90%;
    word-wrap: break-word;

    p {
      margin: 4px 0;
    }

    .hora {
      font-size: 10px;
      text-align: right;
      display: block;
      margin-top: 4px;
      color: #666;
    }
  }
`;

export const ChatFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  border-top: 1px solid #ccc;
`;


export const MessageContainer = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-start;
`;


export const MoreOptions = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 8px;

  button {
    background: transparent;
    border: none;
    color: #1976d2;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      text-decoration: underline;
    }
  }
`;




export default function Chat({ socket, logon, urlApi, onEdit, readOnly }) {
    const [messages, setMessages] = useState([]);
    const [menuAberto, setMenuAberto] = useState(null);
    const [input, setInput] = useState("");
    const bottomRef = useRef();
    const token = localStorage.getItem("token");


    const id_chamado = onEdit.ID_CHAMADO

    useEffect(() => {
        if (!id_chamado) return;

        socket.emit("join_chat", { id_chamado, username: logon });

        socket.on("joined_chat", () => { });

        socket.on("receive_message", (message) => {
            if (message.id_chamado !== id_chamado) return;
            setMessages((prev) => [...prev, { ...message, username: String(message.username) }]);
        });

        socket.on("edit_message", ({ id_mensagem, nova_mensagem }) => {
            setMessages(prev => prev.map(m =>
                m.id_mensagem === id_mensagem
                    ? { ...m, mensagem_enviada: nova_mensagem, mensagem_editada: 'S' }
                    : m
            ));
        });

        socket.on("delete_message", ({ id_mensagem }) => {
            console.log("⚡ Recebi delete_message", id_mensagem);

            setMessages(prev => prev.map(m =>
                Number(m.id_mensagem) === Number(id_mensagem)
                    ? { ...m, mensagem_enviada: "Mensagem apagada pelo usuário" }
                    : m
            ));
        });



        socket.on("error_message", (msg) => {
            alert(msg);
        });

        fetchHistory();

        return () => {
            // 🔥 Desregistra TODOS os eventos
            socket.off("receive_message");
            socket.off("edit_message");
            socket.off("delete_message");
            socket.off("error_message");
            socket.off("joined_chat");
        };
    }, [id_chamado, logon]);


    useEffect(() => {
        return () => {
            socket.emit("leave_chat", { id_chamado, username: logon });
        };
    }, [id_chamado, logon]);



    const fetchHistory = async () => {
        try {
            const res = await fetch(`${urlApi}chat-central-ti/mensagens/${id_chamado}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = await res.json();
            // Normaliza os campos para o frontend
            const mensagensFormatadas = data.map(m => ({
                id_mensagem: Number(m.ID_MENSAGEM),
                id_chamado: m.ID_CHAMADO,
                username: String(m.USERNAME),
                nome: m.DESC_FUNC,
                mensagem_enviada: m.MENSAGEM_ENVIADA,
                data_hora: m.DATA_HORA
            }));


            setMessages(mensagensFormatadas);
            scrollToBottom();
        } catch (err) {
            console.error("Erro ao buscar histórico do chat:", err);
        }
    };

    const sendMessage = () => {
        const texto = input.trim();
        if (!texto) return;

        socket.emit("send_message", {
            id_chamado,
            username: logon,
            mensagem_enviada: texto,
        });

        setInput("");
    };


    const scrollToBottom = () => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (messages.length > 0) {
            scrollToBottom();
        }
    }, [messages]);

    // const editarMensagem = (id_mensagem) => {
    //     const nova_mensagem = prompt("Digite a nova mensagem:");
    //     if (!nova_mensagem) return;

    //     fetch(`${urlApi}chat-central-ti/editar-mensagens/${id_mensagem}`, {
    //         method: 'PUT',
    //         headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    //         body: JSON.stringify({ nova_mensagem })
    //     });
    // };

    const deletarMensagem = (id_mensagem) => {
        fetch(`${urlApi}chat-central-ti/deletar-mensagens/${id_mensagem}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${token}` }
        });
    };

    const menuRef = useRef();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuAberto(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef, setMenuAberto]);

    return (
        <ChatContainer>
            <ChatBody>
                {messages.map((m, idx) => {
                    const dataHora = new Date(m.data_hora);
                    const dataValida = !Number.isNaN(dataHora.getTime());

                    const dataFormatada = dataValida
                        ? dataHora.toLocaleDateString('pt-BR') // "DD/MM/YYYY"
                        : '';
                    const horaFormatada = dataValida
                        ? dataHora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) // "HH:MM"
                        : '';

                    const hora = dataValida ? `${dataFormatada} ${horaFormatada}` : '';

                    if (m.username === "Sistema") {
                        return (
                            <MessageSystem key={idx}>
                                <div>{m.mensagem_enviada} <span className="hora">{hora}</span></div>
                            </MessageSystem>
                        );
                    }

                    const isMe = m.username === logon;

                    return isMe ? (

                        <MessageMine key={idx}>
                            <div className="message-container" ref={menuRef}>
                                <div className="message-header">
                                    <strong>Você:</strong>
                                    <IoEllipsisVertical
                                        size={18}
                                        style={{ cursor: "pointer", color: '#575757' }}
                                        onClick={() => setMenuAberto(m.id_mensagem)}
                                    />
                                </div>

                                <div className="message-body">
                                    {m.mensagem_enviada}
                                </div>

                                <span className="hora">{hora}</span>

                                {menuAberto === m.id_mensagem && (
                                    <MoreOptionsMenu>
                                        <button onClick={() => {
                                            deletarMensagem(m.id_mensagem);
                                            setMenuAberto(null);
                                        }}>Apagar</button>
                                    </MoreOptionsMenu>
                                )}
                            </div>
                        </MessageMine>

                    ) : (
                        <MessageOther key={idx}>
                            <div>
                                <strong>{m.nome || m.desc_func}</strong>
                                <p>{m.mensagem_enviada}</p>
                                <span className="hora">{hora}</span>
                            </div>
                        </MessageOther>
                    );
                })}

                <div ref={bottomRef} />
            </ChatBody>
            {!readOnly && (
                <>
                    <ChatFooter>
                        <Input
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                            fullWidth
                            placeholder="Digite sua mensagem..."
                        />
                        <IoSend
                            size={24}
                            style={{ marginLeft: 10, cursor: "pointer", color: "#1976d2" }}
                            onClick={sendMessage}
                        />
                    </ChatFooter>
                </>
            )}
        </ChatContainer>

    );
}
